import * as React from 'react';

import { Moment } from 'moment';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Icon from '@components/basics/icons';
import Typography from '@components/basics/typography';

type DatepickerControlsAction = 'next:month' | 'prev:month' | 'open:years';

interface DatepickerControlsProps {
  className?: string;
  active: Moment;
  isYearMenuOpen?: boolean;
  hasChanges?: boolean;
  onChange: (action: DatepickerControlsAction) => void;
}

export const DatepickerControls: React.FC<DatepickerControlsProps> = (
  props
) => {
  const handleClick = (
    ev: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    action: DatepickerControlsAction
  ) => {
    ev.preventDefault();
    ev.stopPropagation();
    props.onChange(action);
  };

  return (
    <div
      className={`datepicker-controls ${props.className} ${
        props.hasChanges ? 'has-changes' : ''
      }`}
    >
      <button
        onClick={(ev) => handleClick(ev, 'prev:month')}
        className="month-selector previous"
      >
        <Icon iconType="arrow-left" iconSize="" />
      </button>
      <button
        onClick={(ev) => handleClick(ev, 'open:years')}
        className="month-selector"
      >
        <Flex
          alignItems="center"
          justifyContent="center"
          className="year-selector"
        >
          <Typography weight="700">
            {props.active.format('MMMM YYYY')}
          </Typography>
          <Arrow
            iconType={props.isYearMenuOpen ? 'arrow-up' : 'arrow-down'}
            iconSize=""
          />
        </Flex>
      </button>
      <button
        onClick={(ev) => handleClick(ev, 'next:month')}
        className="month-selector next"
      >
        <Icon iconType="arrow-right" iconSize="" />
      </button>
    </div>
  );
};

export default styled(DatepickerControls)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  @media ${({ theme }) => theme.device.tablet} {
    margin-bottom: 20px;
  }

  &.has-changes {
    .year-selector,
    .month-selector {
      span {
        color: ${({ theme }) => theme.colors.differentBackground};
      }
    }
  }

  .month-selector {
    margin: 0;
    padding: 0;
    cursor: pointer;
    background: none;
    height: 24px;
  }

  .year-selector {
    cursor: pointer;
  }
`;

const Arrow = styled(Icon)`
  margin-left: 8px;
  width: 16px;
  height: 16px;
`;
